export default __webpack_public_path__ + "static/media/Thug's Gloves of the Silent Kill.00ce4910.jpg";